import cpfCnpj from './cpfCnpj'
import date from './date'
import number from './number'
import uppercase from './uppercase'

export default {
  cpfCnpj,
  date,
  number,
  uppercase
}